<template>
  <div class="emotional_movements">
    <!-- 4. 情绪运动 -->
    <titleTem :passTitleData="passTitleData"></titleTem>
    <div class="echarts_container">
      <ETimeLine :echartsData="echartsData" @onEveryLine="onEveryLine" :isNodata="isNodata"></ETimeLine>
    </div>
  </div>
</template>

<script>
import titleTem from "./Title";
import ETimeLine from "../echarts/ETimeLine";
import { feelingTrend } from "@/common/js/http/version3Api.js";

export default {
  name: "EmotionalMovements",
  components: {
    titleTem,
    ETimeLine
  },
  data() {
    return {
      isNodata: false,
      passTitleData: {
        titleName: "Emotion Trend",
        commentTxt:
          "It refers to the emotional trends of postings by foreign media within a certain time frame (in past 7 days by default). Double-click the chart to drill down the data. The number on the left represents the sum of emotion scores (positive: 10, partial positive: 5, neutral: 0, partial negative: -5, and negative: -10)"
      },
      //数据缩放图
      echartsData: []
    };
  },
  mounted() {
    this.getFeelingTrend();
  },
  methods: {
    getFeelingTrend() {
      let data = {
        companyId: this.$route.query.id,
        brandToken: localStorage.getItem("brand-token")
      };
      feelingTrend(data).then(res => {
        let newsArray = [];
        let one = newsArray.push(res.result.xAxis.data, res.result.series);
        this.$set(this.echartsData, "lineData", newsArray);
        this.echartsData = this.echartsData.lineData;
        if (this.echartsData[0].length === 0) {
          this.isNodata = true;
        } else {
          this.isNodata = false;
        }
      });
    },
    //点击柱状图
    onEveryLine(params) {
      const eChart = echarts.init(this.$refs.dataEchart);

      eChart.getZr().on("click", () => {});

      eChart.on("click", data => {});
    }
  }
};
</script>

<style scoped>
.title {
  margin-top: 70px;
}
@media screen and (max-width: 1024px) {
  .title {
    margin-top: 20px;
  }
}
@media screen and (max-width: 768px) {
  .title {
    margin-top: 30px;
  }
}
@media screen and (max-width: 480px) {
  .title {
    margin-top: -60px;
  }
}
</style>